<template>
    <ul class="text-base">
        <li
            v-for="(resourceGroup, groupType) in resources"
            :key="groupType"
            class="block gap-2 pl-0"
        >
            <button
                class="type-secondary hover:type-primary flex items-center gap-2 py-4 font-bold capitalize w-full sticky top-0 bg-gray-tier-3 z-10 border-b border-b-keyline-primary"
                :class="{
                    '!type-primary' : resourceOpen[groupType],
                }"
                @click.prevent="
                    resourceOpen[groupType]
                        ? (resourceOpen[groupType] = false)
                        : (resourceOpen[groupType] = true)
                "
            >
                <BaseSvg
                    :name="
                        resourceOpen[groupType]
                            ? 'icon-expand-less'
                            : 'icon-expand-more'
                    "
                    class="w-6 h-6 type-secondary"
                />
                {{ groupType }}
            </button>
            <ul v-if="resourceOpen[groupType]">
                <li v-for="(resource, i) in resourceGroup" :key="i" class="group border-b border-keyline-primary last:border-b-0">
                    <div class="flex items-center gap-3 p-2 hover:bg-gray-tier-5 text-sm">
                        <BaseSvg
                            :name="getIcon(groupType)"
                            class="w-5 h-auto shrink-0 type-tertiary"
                        />
                        <button
                            @click.stop.prevent="getResource($event, resource)"
                            class="text-left hover:underline underline-offset-4 decoration-1 capitalize truncate max-w-[80%]"
                        >
                            {{ resource.name }}
                        </button>

                        <div class="hidden at1024:flex items-center justify-end gap-8 whitespace-nowrap col-span-1 ml-auto">
                            <span
                                class="hidden at1200:block type-secondary"
                            >
                                {{ resource?.asset?.updated_at ? DateTime.fromISO(resource?.asset?.updated_at).toLocaleString(DateTime.DATE_MED) : "–"}}
                            </span>
                            <span class="relative w-fit pr-2">
                                <button
                                    class="opacity-0 group-hover:opacity-50 active:!opacity-100 hover:!opacity-100"
                                    :class="state.isOpen === resource.name ?'!opacity-100':''"
                                    @click="state.isOpen === resource.name ? state.isOpen = false: state.isOpen = resource.name"
                                >
                                    <BaseSvg name="icon-more-horiz" />
                                </button>
                                <Transition name="search-pop">
                                    <ActionDropdown
                                        v-click-outside="close"
                                        v-if="state.isOpen === resource.name "
                                        :offset="{right:0}"
                                        :options="getOptions(resource)"
                                    />
                                </Transition>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script setup>
import { BaseSvg, ActionDropdown } from "@/Components";
import { useAssetTransforms, useDownload, useResources, usePinsDrawer } from "@/Composables";
import { ref, reactive } from "vue";
import _ from "lodash";
import { DateTime } from "luxon";

const props = defineProps({
    resources: {
        type: Array,
        required: false,
    },
    icons: {
        type: Array,
        required: true,
    },
    getIcon: {
        type: Function,
        required: true,
    },
});

const resourceOpen = ref({});

const getOptions = (resource) => {
    const options = [];
    
    // Only add download option if resource.asset.source === 3
    if (resource?.asset?.source === 3) {
        options.push({
            icon: 'file-download',
            label: 'Download',
            action: (event) => forceDownload(event, marketingAssetUrl(resource?.asset?.external_id), _.kebabCase(resource?.name)+'.pdf')
        });
    }
    
    // Always add pin option
    options.push({
        icon: 'push-pin-outlined',
        label: 'Pin this resource',
        action: () => {
            togglePin('resource', resource?.id);
            close();
        }
    });
    
    return [options];
};

const state = reactive({
    isOpen: false,
});

const close = () => state.isOpen = false;

const { getResource } = useResources();
const { marketingAssetUrl } = useAssetTransforms();
const { forceDownload } = useDownload();
const { fetchPin, togglePin, removePin, openDrawerTray } = usePinsDrawer();
</script>
